import { useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import NotFound from "../../../components/not-found";
import GreetingMembershipService from "../../../services/GreetingMembershipService";
import GreetingMembership from "../../../models/GreetingMembership";
import GreetingMembershipEditForm from "./ui/greeting-membership-edit-form";
import GreetingMembershipSkeleton from "./skeleton/greeting-membership-skeleton";

export default function GreetingMembershipEditPage() {
  const [searchParams] = useSearchParams();
  const { id } = useParams();
  const api = new GreetingMembershipService();
  const [item, setItem] = useState<GreetingMembership>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void fetchItem();
  }, [id, searchParams.get("reload")]);

  const fetchItem = async () => {
    if (!id) {
      setLoading(false);
      return;
    }

    try {
      const data = await api.getGreetingMembershipById(id);
      setItem(data);
    } catch (error) {
      console.error("Error fetching greeting membership:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!item && !loading) {
    return <NotFound message="Greeting membership not found." />;
  }

  return (
    <main className="max-w-3xl">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Greeting Memberships", href: "/admin/greeting-memberships" },
          {
            label: "Edit",
            href: `/admin/greeting-memberships/edit/${id}`,
            active: true,
          },
        ]}
      />
      {!loading && item ? (
        <GreetingMembershipEditForm item={item} />
      ) : (
        <GreetingMembershipSkeleton />
      )}
    </main>
  );
}
